import { Box, Chip, Container, Paper, Typography } from '@material-ui/core';
import Button, { ButtonColors } from 'components/Button';
import React, { useEffect } from 'react';
import T from 'i18n-react';
import moment from 'moment';
import { Table } from 'components';
import { LoadingBackdrop } from 'components/Loading';
import { GetApp as DownloadIcon } from '@material-ui/icons';
import { openFileURL } from 'util/file';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { onBufferingFile } from 'util/fileUtil';
import qmasLogo from 'assets/img/qmas_logo_w.png';
import { PRODUCT_TESTING_LANG_PATH } from 'shared/path';
import { setLanguageLocale } from 'util/icwUtility';
import { DATE_FORMAT_01 } from 'shared/constants';

setLanguageLocale(T, [PRODUCT_TESTING_LANG_PATH]);

const ShareReport = ({
  location,
  getShareReport,
  shareReportLoading,
  shareReportList,
  downloadReportListJobDetailForPublic,
  reportDownloadedListJobDetail,
  reportDownloadedListJobDetailLoading,
  downloadReportListJobDetailReset,
}) => {
  const token = location?.search?.split('?token=')?.[1];

  const downloadAction = (event, url) => {
    event.stopPropagation();
    openFileURL(url);
  };

  const handleDownloadReport = () => {
    const reportIds = shareReportList?.list?.map((item) => item.id);

    if (reportIds.length) {
      let productTestingId = shareReportList.list[0].productTestingId;
      downloadReportListJobDetailForPublic(productTestingId, { selectedReports: reportIds });
    }
  };

  const tableColumns = [
    {
      columnId: 'reportName',
      width: '100%',
      label: T.translate('productTesting.jobDetails.actions.reports.reportName'),
      render: ({ reportName = '' }) => (
        <Box fontSize={12} fontWeight={400}>
          {reportName}
        </Box>
      ),
    },
    {
      columnId: 'size',
      width: '100%',
      label: T.translate('productTesting.jobDetails.actions.reports.size'),
      render: ({ documentList = '' }) => (
        <Box fontSize={12} fontWeight={400}>
          {documentList?.fileSize}
        </Box>
      ),
    },
    {
      columnId: 'issueDate',
      width: '100px',
      label: T.translate('productTesting.jobDetails.actions.reports.issueDate'),
      render: ({ issueDate = '' }) => (
        <Box fontSize={12} fontWeight={400}>
          {issueDate && moment(issueDate).format(DATE_FORMAT_01)}
        </Box>
      ),
    },
    {
      columnId: 'expiryDate',
      width: '100px',
      label: T.translate('productTesting.jobDetails.actions.reports.reportExpiryDate'),
      render: ({ expiryDate = '' }) => (
        <Box fontSize={12} fontWeight={400}>
          {expiryDate && moment(expiryDate).format(DATE_FORMAT_01)}
        </Box>
      ),
    },
    {
      columnId: 'result',
      width: '100%',
      label: T.translate('productTesting.jobDetails.actions.reports.result'),
      render: ({ result: res = '' }) => {
        let color = '';
        let backgroundColor = '';
        if ((res || '').toLowerCase() === 'pass') {
          color = '#1BB135';
          backgroundColor = 'rgba(50, 200, 50, 0.1)';
        } else if ((res || '').toLowerCase() === 'fail') {
          color = '#D42600';
          backgroundColor = ' rgba(255, 85, 85, 0.1)';
        } else if ((res || '').toLowerCase() === 'reportAsIs') {
          color = '#3A4861';
          backgroundColor = 'rgba(235, 237, 239, 0.5)';
        }

        return (
          res && (
            <Chip
              style={{
                color,
                background: backgroundColor,
                fontWeight: 400,
                fontSize: 12,
              }}
              label={T.translate(`productTesting.result.${res}`)}
            />
          )
        );
      },
    },
    {
      columnId: 'reportName',
      render: ({ url }) => {
        return (
          <Button
            type='native-icon'
            buttonProps={{
              icon: <DownloadIcon />,
              onClick: (event) => downloadAction(event, url),
            }}
          />
        );
      },
    },
  ];

  useEffect(() => {
    if (token) getShareReport(token);
  }, [token]);

  useEffect(() => {
    const zipData = get(reportDownloadedListJobDetail, 'data', []);
    if (!reportDownloadedListJobDetailLoading && !isEmpty(zipData)) onBufferingFile(zipData);
    return () => {
      downloadReportListJobDetailReset();
    };

    // eslint-disable-next-line
  }, [reportDownloadedListJobDetail]);

  return (
    <Box>
      {shareReportLoading && <LoadingBackdrop />}
      <Box
        style={{
          background: 'linear-gradient(90.06deg, #2F82FF 0%, #2154A2 100%)',
        }}
        padding={2}>
        <img alt='' src={qmasLogo} width={65} height={20} />
      </Box>
      <Container>
        <Box display='flex' flexDirection='column' alignItems='center' marginTop='60px'>
          <Typography style={{ fontSize: 24, marginBottom: 8, fontWeight: 500 }}>
            {shareReportList?.email?.senderName}{' '}
            {T.translate('productTesting.actionReport.messages.shares')}{' '}
            {shareReportList?.list?.length}{' '}
            {shareReportList?.list?.length > 1
              ? T.translate('productTesting.actionReport.messages.createSuccess2')
              : T.translate('productTesting.actionReport.messages.createSuccess1')}
          </Typography>
          <Typography style={{ marginBottom: 20 }}>
            {T.translate('productTesting.actionReport.messages.sharableLink')}{' '}
            {shareReportList?.email?.expiryDate}
          </Typography>
          <Button
            buttonProps={{
              color: ButtonColors.PRIMARY,
              buttonStyle: {
                background: '#005EFF',
                textTransform: 'none',
              },
              onClick: handleDownloadReport,
            }}>
            {T.translate('productTesting.shareReport.downloadAll')}
          </Button>
          <Paper
            style={{
              width: '100%',
              marginTop: 36,
              padding: 36,
            }}>
            <Table data={shareReportList?.list} columnData={tableColumns} noPagination />
          </Paper>
        </Box>
      </Container>
    </Box>
  );
};

export default ShareReport;
